import {types} from '../../types';

const setGetCashiersProfileAction = (payload) => {
  return {
    type: types.report.SET_CASHIERS_PROFILE,
    payload
  }
}

export {
  setGetCashiersProfileAction as SetGetCashiersProfileAction
}